module.exports = __webpack_public_path__ + "img/antiguaandbarbuda.699b6b31.svg";